import { numberFormatter } from 'core/helpers/formatters';

function CreditCardFeeDisclaimer({ amount }) {
  return (
    <div>
      <small>
        *Credit card payments are subject to a processing fee of <strong>2.8% + 25¢</strong> on top of the set amount{' '}
        {!!amount && <strong>(${numberFormatter(amount * 0.028 + 0.25, 2)})</strong>}.
      </small>
    </div>
  );
}

export default CreditCardFeeDisclaimer;
